import { render, staticRenderFns, recyclableRender, components } from "./u-grid-item.vue?vue&type=template&id=5b3a01af&scoped=true&"
var renderjs
import script from "./u-grid-item.vue?vue&type=script&lang=js&"
export * from "./u-grid-item.vue?vue&type=script&lang=js&"
import style0 from "./u-grid-item.vue?vue&type=style&index=0&id=5b3a01af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../Program Files/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3a01af",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "uni_modules/uview-ui/components/u-grid-item/u-grid-item.vue"
export default component.exports